import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const UserTwoFaCredential = React.lazy(() =>
    import('../UserTwoFaCredential')
);
const userTwoFaCredentialRoutesRegistry = [
    {
        path: PAGE_URL.USER_TWO_FA_CREDENTIAL_PAGE,
        element: <UserTwoFaCredential />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default userTwoFaCredentialRoutesRegistry;
